import { Controller } from "react-hook-form";
import { Input, InputProps } from "@mui/base/Input";
import InputError from "../InputError";
import "./TextField.scss";

interface TextInputProps {
  id?: string;
  name: string;
  label?: string;
  control: any;
  hideErrors?: boolean;
  placeholder?: string;
  pattern?: RegExp;
  onBlur?: () => void;
}

/**
 * Wrapper for a MUI textfield integrated with React Hook Form
 */
export const TextField = (props: TextInputProps & InputProps) => {
  const {
    id,
    name,
    label,
    onBlur,
    control,
    placeholder,
    pattern,
    hideErrors = false,
    ...rest
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        console.log("error: ", error);
        return (
          <div className="custom-field__container">
            {label && (
              <label className="custom-field__label" htmlFor={name}>
                {label}
              </label>
            )}
            <Input
              id={name}
              className="custom-field"
              name={name}
              error={!!error}
              onChange={
                pattern
                  ? (event: any) => {
                      let value: string = event.target.value;
                      if (value !== "" && pattern) {
                        value = pattern.exec(value)?.[0] ?? "";
                      }
                      field.onChange(value);
                    }
                  : field.onChange
              }
              value={field.value}
              placeholder={placeholder}
              onBlur={onBlur}
              {...rest}
            />
            {!!error && !hideErrors && <InputError>{error.message}</InputError>}
          </div>
        );
      }}
    />
  );
};

export default TextField;
